import React, { Fragment, useState } from "react";
import Select, { components } from "react-select";
import { Button, Row, Col, Checkbox, Typography } from "antd";
import { OmitProps } from "antd/lib/transfer/ListBody";
import { FilterOutlined } from "@ant-design/icons";

const { Text } = Typography;
const Menu = (props) => {
  const disabled = !props?.options?.length;
  return (
    <Fragment>
      <components.Menu {...props}>
        <div>
          <div>{props.children}</div>
          <Row justify="space-around" style={{ padding: "10px 0" }}>
            <Col>
              <Button
                size="medium"
                onClick={() => {
                  props.selectProps.resetClicked();
                }}
                disabled={disabled}
              >
                Reset
              </Button>
            </Col>
            <Col>
              <Button
                type="ghost"
                style={{
                  background: disabled ? "#f5f5f5" : "#333",
                  color: disabled ? "#bbb" : "#f5f5f5",
                  border: "none",
                }}
                size="medium"
                className={"change-data"}
                disabled={disabled}
                onClick={props.selectProps.applyClicked}
              >
                Apply
              </Button>
            </Col>
          </Row>
        </div>
      </components.Menu>
    </Fragment>
  );
};
const Option = (props) => {
  const { selectProps } = props;
  const selectedSet = new Set(selectProps.selected);
  const checked = selectedSet.has(props.data.value);
  return (
    <Fragment>
      <Row style={{ "border-bottom": "1px solid #ccc" }}>
        <Col>
          <Checkbox
            className="catalogue-filter-checkbox"
            onClick={(e) => {
              selectProps.handleChange(e.target.value, e.target.checked);
            }}
            checked={checked}
            children={props.children}
            style={{
              padding: "5px 5px 5px 10px ",
              justifyContent: "center",
            }}
            value={props.data.value}
          ></Checkbox>
        </Col>
        {/* <Col>
          <components.Option {...props} style={{ background: "white" }}>
            {props.children}
          </components.Option>
        </Col> */}
      </Row>
    </Fragment>
  );
};

const CustomSelect = ({
  options,
  changeOptionsData,
  fetchingData,
  onButtonClick,
  onChange,
  placeholder,
  selected,
  onReset,
  labelOptions = {},
}) => {
  const useRef = React.createRef();
  const [isClicked, setIsClicked] = useState(false);
  const [showMenu, setShowMenu] = useState(false);

  const resetClicked = (e) => {
    useRef.current.blur();
    removeFocus();
    onReset(e);
  };

  const applyClicked = (e) => {
    useRef.current.blur();
    // const { selected = [] } = useRef?.current?.props;
    // if (selected.includes("All Buyers") || selected.includes("All Users"))
    //   return;
    removeFocus();
    onButtonClick(e);
  };
  const setFocus = () => {
    setShowMenu(true);
  };

  const removeFocus = (e) => {
    if (e?.nativeEvent?.relatedTarget) {
      let x = useRef.current.inputRef.id;
      let y = e?.nativeEvent?.relatedTarget.id;
      if (y && x !== y) {
        setShowMenu(false);
      } else {
        useRef.current.focus();
        return;
      }
    } else {
      setShowMenu(false);
    }
  };
  return (
    <div>
      <Select
        theme={(theme) => ({
          ...theme,
          colors: {
            ...theme.colors,
            primary: "#278977",
          },
        })}
        styles={{
          indicatorSeparator: () => ({
            display: "none",
          }),
          indicatorsContainer: (base) => ({
            ...base,
            background: selected.some((r) =>
              ["All Buyers", "All Users"].includes(r)
            )
              ? "#fff"
              : "#f5f5f5",
            height: "36px",
            borderRadius: "0 4px 4px 0",
            border: selected.some((r) =>
              ["All Buyers", "All Users"].includes(r)
            )
              ? "none"
              : "1px solid black",
            "border-left": "none",
          }),
          valueContainer: (base) => ({
            ...base,
            borderRadius: "4px 0 0 4px",
            background: selected.some((r) =>
              ["All Buyers", "All Users"].includes(r)
            )
              ? "#fff"
              : "#f5f5f5",
            color: "#777",
            width: "80%",
            border: selected.some((r) =>
              ["All Buyers", "All Users"].includes(r)
            )
              ? "none"
              : "1px solid black",

            "border-right": "none",
            height: "36px",
            fontWeight: selected.some((r) =>
              ["All Buyers", "All Users"].includes(r)
            )
              ? "normal"
              : "bold",
          }),
        }}
        ref={useRef}
        options={options}
        components={{ Menu, Option }}
        fetchingData={fetchingData}
        changeOptionsData={changeOptionsData}
        onChange={onChange}
        handleChange={onChange}
        placeholder={placeholder}
        onButtonClick={onButtonClick}
        selected={selected}
        resetClicked={resetClicked}
        applyClicked={applyClicked}
        onFocus={setFocus}
        onBlur={removeFocus}
        menuIsOpen={showMenu}
        //override with label options if present, else show selected values.
        //if selected values is empty, show placeholder instead
        value={{
          label: selected.length
            ? Object.keys(labelOptions).length
              ? selected.length > 1
                ? labelOptions[selected[0]]
                  ? `${labelOptions[selected[0]]} +${selected.length - 1} more`
                  : selected[0]
                : labelOptions[selected[0]] ?? selected[0]
              : selected.length > 1
              ? `${
                  selected[0].charAt(0).toUpperCase() + selected[0].slice(1)
                } +${selected.length - 1} more`
              : selected[0].charAt(0).toUpperCase() + selected[0].slice(1)
            : placeholder,
        }}
      />
    </div>
  );
};
export default CustomSelect;
